"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_DROPDOWN_OPTIONS = exports.DEFAULT_DROPDOWN_TYPE = exports.LABEL_PADDING_Y = exports.LABEL_PADDING_X = exports.LABEL_SECTION_WIDTH = exports.RECT_PADDING_X = exports.RECT_PADDING_Y = void 0;
exports.RECT_PADDING_Y = 6;
exports.RECT_PADDING_X = 2;
exports.LABEL_SECTION_WIDTH = 85;
exports.LABEL_PADDING_X = 8;
exports.LABEL_PADDING_Y = 6;
exports.DEFAULT_DROPDOWN_TYPE = 'items';
exports.DEFAULT_DROPDOWN_OPTIONS = {
  enabled: true,
  selectedItem: null,
  show: true,
  sort: true,
  type: exports.DEFAULT_DROPDOWN_TYPE
};